import React from "react";
import { Button, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import FilterAge from "../../talents/talentListNew/filterComponents/filterAge";
import FilterWeight from "../../talents/talentListNew/filterComponents/filterWeight";
import FilterMultiSelectBox from "../../talents/talentListNew/filterComponents/filterMultiSelectBox";
import {
  ethnicityList, eyeColorList, genderList, hairColorList,
  inchesList, maxHeightFeetList, minHeightFeetList, uuidMapping,
} from "../../talents/talentListNew/helper";

export const buildFilterDescriptions = ({
  roleCompTags,
  ageValues, setAgeValues,
  weightValues, setWeightValues,
  minFeet, setMinFeet, minInches, setMinInches,
  maxFeet, setMaxFeet, maxInches, setMaxInches,
  selectedGender, setSelectedGender,
  selectedEthnicity, setSelectedEthnicity,
  selectedEyeColor, setSelectedEyeColor,
  selectedHairColor, setSelectedHairColor,
  showEditIcon,
  addTagForEdit,
  onRoleCompositionChange,
}) => [
  {
    title: "Age",
    person_attribute_uuid: uuidMapping.age,
    description: () => (
      <FilterAge
        talentFilter={null}
        talentFilterTags={roleCompTags}
        controlledValues={ageValues}
        onAddFilter={(_, payload) => {
          const newValues = {
            start_value: payload.attribute.start_value,
            end_value: payload.attribute.end_value,
          };

          setAgeValues(newValues);

          if (showEditIcon) {
            addTagForEdit(uuidMapping.age, newValues);
          } else {
            onRoleCompositionChange(uuidMapping.age, newValues);
          }
        }}
      />
    ),
  },
  {
    title: "Gender",
    person_attribute_uuid: uuidMapping.gender,
    description: () => (
      <FilterMultiSelectBox
        onChange={setSelectedGender}
        title="GENDER (Select one or several)"
        label="Select gender or search"
        list={genderList}
        selectedValue={selectedGender}
        type="gender"
        btnContent="Select"
        onAddFilter={() =>
          showEditIcon
            ? addTagForEdit(uuidMapping.gender, selectedGender)
            : onRoleCompositionChange(uuidMapping.gender)
        }
      />
    ),
  },
  {
    title: "Ethnicity",
    person_attribute_uuid: uuidMapping.ethnicity,
    description: () => (
      <FilterMultiSelectBox
        onChange={setSelectedEthnicity}
        title="ETHNICITY (Select one or several)"
        label="Select ethnicity or search"
        list={ethnicityList}
        selectedValue={selectedEthnicity}
        type="ethnicity"
        btnContent="Select"
        onAddFilter={() =>
          showEditIcon
            ? addTagForEdit(uuidMapping.ethnicity, selectedEthnicity)
            : onRoleCompositionChange(uuidMapping.ethnicity)
        }
      />
    ),
  },
  {
    title: "Height",
    person_attribute_uuid: uuidMapping.height,
    description: () => (
      <div className="p-[12px]">
        <div>Select height range</div>
        <div className="border border-[#D9D9D9] rounded py-1 px-2 filter-select mb-2">
          <div>MIN</div>
          <Select placeholder="Feet" style={{ width: 120 }} value={minFeet} options={minHeightFeetList} onChange={setMinFeet} />
          <Select placeholder="Inches" style={{ width: 120 }} value={minInches} options={inchesList} onChange={setMinInches} />
        </div>
        <div className="border border-[#D9D9D9] rounded py-1 px-2 filter-select">
          <div>MAX</div>
          <Select placeholder="Feet" style={{ width: 120 }} value={maxFeet} options={maxHeightFeetList} onChange={setMaxFeet} />
          <Select placeholder="Inches" style={{ width: 120 }} value={maxInches} options={inchesList} onChange={setMaxInches} />
        </div>
        <div className="text-right">
          <Button
            disabled={
              parseInt(maxFeet) * 12 + parseInt(maxInches) <=
                parseInt(minFeet) * 12 + parseInt(minInches) ||
              !minFeet || !maxFeet || !minInches || !maxInches
            }
            className="mt-[10px]"
            onClick={() =>
              showEditIcon
                ? addTagForEdit(uuidMapping.height, {
                    start_value: `${minFeet}'${minInches}"`,
                    end_value: `${maxFeet}'${maxInches}`,
                  })
                : onRoleCompositionChange(uuidMapping.height)
            }
            icon={<PlusOutlined className="align-baseline" />}
          >
            Select
          </Button>
        </div>
      </div>
    ),
  },
  {
    title: "Weight",
    person_attribute_uuid: uuidMapping.weight,
    description: () => (
      <FilterWeight
        talentFilter={null}
        talentFilterTags={roleCompTags}
        controlledValues={weightValues}
        onAddFilter={(_, payload) => {
          const newValues = {
            start_value: payload.attribute.start_value,
            end_value: payload.attribute.end_value,
          };

          setWeightValues(newValues);

          if (showEditIcon) {
            addTagForEdit(uuidMapping.weight, newValues);
          } else {
            onRoleCompositionChange(uuidMapping.weight, newValues);
          }
        }}
      />
    ),
  },
  {
    title: "Eye color",
    person_attribute_uuid: uuidMapping.eyeColor,
    description: () => (
      <FilterMultiSelectBox
        onChange={setSelectedEyeColor}
        title="EYE COLOR (Select one or several)"
        label="Select eye color or search"
        list={eyeColorList}
        selectedValue={selectedEyeColor}
        type="eye_color"
        btnContent="Select"
        onAddFilter={() =>
          showEditIcon
            ? addTagForEdit(uuidMapping.eyeColor, selectedEyeColor)
            : onRoleCompositionChange(uuidMapping.eyeColor)
        }
      />
    ),
  },
  {
    title: "Hair color",
    person_attribute_uuid: uuidMapping.hairColor,
    description: () => (
      <FilterMultiSelectBox
        onChange={setSelectedHairColor}
        title="HAIR COLOR (Select one or several)"
        label="Select hair color or search"
        list={hairColorList}
        selectedValue={selectedHairColor}
        type="hair_color"
        btnContent="Select"
        onAddFilter={() =>
          showEditIcon
            ? addTagForEdit(uuidMapping.hairColor, selectedHairColor)
            : onRoleCompositionChange(uuidMapping.hairColor)
        }
      />
    ),
  },
];
